function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Input } from "antd";
import cls from "classnames";
import { useEffect, useRef } from "react";
import useState from "react-usestateref";
import styles from "./InterviewBot.module.scss";
import MakeACall from "./MakeACall";
import React from "react";
import { NodesUtil } from "../NodesUtil";
var TextArea = Input.TextArea;
function InterviewBot(props) {
  var textAreaValue = props.textAreaValue;
  var _ref = textAreaValue !== null && textAreaValue !== void 0 ? textAreaValue : {
      msg: "",
      loading: false
    },
    msg = _ref.msg,
    loading = _ref.loading;
  var _useState = useState(msg),
    _useState2 = _slicedToArray(_useState, 2),
    AIDesc = _useState2[0],
    setAIDesc = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var textareaRef = useRef(null);
  var handleFocus = function handleFocus() {
    props.onTextAreaFocus();
    setFocused(true);
  };
  var handleBlur = function handleBlur() {
    setFocused(false);
  };
  var handleChangeTextarea = function handleChangeTextarea(e) {
    setAIDesc(e.target.value);
  };
  var handleUpdateAgentDescription = function handleUpdateAgentDescription() {
    console.error("called");
  };
  useEffect(function () {
    if (msg) {
      setAIDesc(msg);
    }
  }, [msg]);
  var whatTodoClassName = cls(styles.whatTodo, NodesUtil.constants.NO_WHEEL, focused && styles.focused, focused && "nodrag");
  return /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/React.createElement(TextArea, {
    ref: textareaRef,
    rows: 8,
    onClick: handleFocus,
    onBlur: handleBlur,
    onChange: handleChangeTextarea,
    className: whatTodoClassName,
    value: AIDesc || "",
    onPressEnter: handleUpdateAgentDescription,
    placeholder: "What do you want the AI to do",
    autoSize: true
  }), /*#__PURE__*/React.createElement(MakeACall, {
    edgeDataLoading: loading,
    AIDesc: AIDesc,
    msg: msg,
    onFocus: function onFocus() {
      return props.onTextAreaFocus();
    }
  }));
}
export { InterviewBot };